import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";

function ProtectedRouteRole({ children,authorizedRoles }) {
  const token = useSelector((state)=>state.user.token);
  const role = useSelector((state)=>state.user.role);
  if (!token) {
    return <Navigate to="/login" replace />;
  }else if(!authorizedRoles.some(r => r === role)){
    return <Navigate to="/" replace />;
  }
  return children ? children : <Outlet />;
}

export default ProtectedRouteRole;